export var REQUIRED = 'REQUIRED';
export var getFileIdsFromFiles = function getFileIdsFromFiles(files) {
  return files.map(function (file) {
    return file.id.toString();
  });
};
export var validateAttachment = function validateAttachment(value, isRequired) {
  if (isRequired) {
    if (!value || value.length === 0) {
      return REQUIRED;
    }
  }
  return undefined;
};
export var getFieldDropZoneContainerID = function getFieldDropZoneContainerID(fieldId) {
  return "".concat(fieldId ? "".concat(fieldId, "-") : '', "dropzone-container");
};